<template>
    <div class="xbk_menu_wrap">
        <div class="menu_bar">
            <div
                @click="selectCategory(index)"
                :class="activeIdx == index ? 'menu_item active' : 'menu_item'"
                v-for="(item, index) in categoryList"
                :key="index"
            >
                {{ item.name }}
            </div>
        </div>
        <div class="product_list" id="product_list" ref="scroll_box">
            <div
                class="section"
                v-for="(item, index) in productList"
                :key="index"
                :id="'view' + index"
            >
                <h3 class="section_title">{{ item[0] }}</h3>
                <div
                    class="product_item fr ac"
                    v-for="(pItem, pIndex) in item[1]"
                    :key="pIndex"
                >
                    <img :src="imgBaseUrl + pItem.logo" alt />
                    <div class="product_info fc jsb">
                        <h4>{{ pItem.name }}</h4>
                        <div class="fr ac jsb">
                            <span class="price">￥{{ pItem.price }}</span>
                            <div class="btn_wrap">
                                <button
                                    @click="selectProp(index, pIndex, pItem)"
                                >
                                    选规格
                                </button>
                                <span class="qty" v-show="pItem.qty">{{
                                    pItem.qty
                                }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer fr ac jsb">
            <div class="footer_left fr ac">
                <div class="icon_wrap" @click="toggleCart">
                    <img src="../../../static/imgs/xbk/xbk_cart.png" alt />
                    <span class="total" v-show="cartQty">{{ cartQty }}</span>
                </div>
                <div class="fc">
                    <span class="total_price" v-show="cartTotal"
                        >￥{{ cartTotal }}</span
                    >
                    <span class="delivery">配送费{{expressfee}}元</span>
                </div>
            </div>
            <button v-if="cartQty > 1" class="btn_active" @click="checkOut">
                去结算
            </button>
            <button v-else class="btn_disable">两杯起送</button>
        </div>
        <div v-show="showProps" class="option_layer">
            <h4>{{ selectedProduct.name }}</h4>
            <div class="props fc">
                <div
                    class="prop"
                    v-for="(item, index) in selectedProduct.attributeList"
                    :key="index"
                >
                    <h5>{{ item.name }}：</h5>
                    <div class="options fr fw">
                        <span
                            :class="
                                oItem.isSelected ? 'option selected' : 'option'
                            "
                            v-for="(oItem, oIdx) in item.valueList"
                            :key="oIdx"
                            @click="selectOption(index, oIdx)"
                            >{{ oItem.name }}</span
                        >
                    </div>
                </div>
            </div>
            <div class="layer_footer fr ac jsb">
                <div class="price_wrap fr ac">
                    <span class="option_price"
                        >￥{{ selectedProduct.realPrice }}</span
                    >
                    <span class="option_detail"
                        >({{ selectedProduct.propsTxt }})</span
                    >
                </div>
                <div v-if="selectedProduct.qty" class="option_num fr ac">
                    <span class="operate center" @click="changeQty('minus')"
                        >-</span
                    >
                    <span class="num">{{ selectedProduct.qty }}</span>
                    <span class="operate center" @click="changeQty('add')"
                        >+</span
                    >
                </div>
                <button v-else @click="addToCart">加入购物车</button>
            </div>
        </div>
        <div v-show="showProps" @click="toggleLayer" class="shade"></div>
        <div v-show="showCart" class="cart_layer fc">
            <div class="cart_items">
                <div class="cart_item_wrap">
                    <div
                        class="cart_item fr ac"
                        v-for="(item, index) in cartArr"
                        :key="index"
                    >
                        <img
                            class="item_pic"
                            :src="imgBaseUrl + item.logo"
                            alt
                        />
                        <div class="item_info fc jsb">
                            <h5>{{ item.name }}</h5>
                            <span class="item_prop">{{ item.propsTxt }}</span>
                            <div class="fr ac jsb">
                                <span class="item_price"
                                    >￥{{ item.realPrice }}</span
                                >
                                <div class="item_num fr ac">
                                    <span
                                        class="operate center"
                                        @click="modifyCartNum('minus', index)"
                                        >-</span
                                    >
                                    <span class="num">{{ item.qty }}</span>
                                    <span
                                        class="operate center"
                                        @click="modifyCartNum('add', index)"
                                        >+</span
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-show="showCart" @click="toggleCart" class="shade"></div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            imgBaseUrl: this.$global.imgBaseUrl,
            categoryList: [],
            productList: [],
            heightArr: [],
            activeIdx: 0,
            showProps: false,
            cartArr: [],
            selectedProduct: {},
            showCart: false,
            categoryIdx: 0,
            productIdx: 0,
            cartQty: 0,
            cartTotal: 0,
            scroll: 0,
            expressfee: 0,
        };
    },
    components: {},
    created() {
        this.getProductList();
    },
    watch: {
        cartArr(val, oldVal) {
            console.log("cartArr:", val, "old cartArr:", oldVal)
            if (!val.length) {
                this.getProductList();
                this.selectedProduct = {};
                this.showCart = false;
                this.showProps = false;
            }
        },
    },
    activated() {
        this.cartArr = this.getLocal("xbkCartArr")
            ? this.getLocal("xbkCartArr")
            : [];
        this.calcCartTotal();
    },
    updated() {
        let productListEle = document.getElementById("product_list");
        if (productListEle) {
            productListEle.addEventListener(
                "scroll",
                this.handleScrollList,
                true
            );
        }
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            const scroll_box = vm.$refs.scroll_box;
            // 记录滚动高度
            scroll_box.scrollTop = vm.scroll;
        });
    },
    beforeRouteLeave(to, from, next) {
        const scroll_box = this.$refs.scroll_box;
        this.scroll = scroll_box.scrollTop;
        next();
    },
    methods: {
        handleScrollList() {
            let listEle = document.getElementById("product_list");
            let scrollTop = listEle.scrollTop;
            this.calcActiveIdx(scrollTop);
        },
        calcActiveIdx(num) {
            let heightArr = this.heightArr;
            for (let idx in heightArr) {
                if (num < heightArr[idx]) {
                    this.activeIdx = idx;
                    break;
                }
            }
        },
        selectCategory(idx) {
            this.activeIdx = idx;
            let viewId = "view" + idx;
            document
                .getElementById(viewId)
                .scrollIntoView({ behavior: "smooth" });
        },
        getProductList() {
            this.$post({
                method: "starbucks.product.list",
            }).then((res) => {
                if (res.success) {
                    let keyArr = Object.keys(res.data.productList),
                        categoryList = [];
                    for (let i of keyArr) {
                        let idx = i.indexOf("@"),
                            categoryObj = {};
                        categoryObj.name = i;
                        categoryList.push(categoryObj);
                    }
                    let productList = Object.entries(res.data.productList);
                    this.categoryList = categoryList;
                    this.productList = productList;
                    this.expressfee = productList[0][1][0].expressfee;
                    console.log(productList);
                    let widthUnit = document.documentElement.clientWidth / 750;
                    let height = 0,
                        heightArr = [];
                    for (let i of this.productList) {
                        height += parseInt(
                            i[1].length * 220 * widthUnit + 69 * widthUnit
                        );
                        heightArr.push(height);
                    }
                    this.heightArr = heightArr;
                    console.log(heightArr);
                }
            });
        },
        selectProp(idx, pidx, info) {
            let categoryIdx = idx,
                productIdx = pidx;
            for (let i of info.attributeList) {
                for (let j in i.valueList) {
                    i.valueList[j].isSelected = j == 0 ? true : false;
                }
            }
            console.log(info);
            let selectedProduct = {},
                cartArr = this.cartArr;
            if (cartArr.length) {
                for (let item of cartArr) {
                    if (item.id == info.id) {
                        selectedProduct = item;
                        break;
                    }
                    selectedProduct = info;
                }
            } else {
                if (
                    JSON.stringify(this.selectedProduct) != "{}" &&
                    this.selectedProduct.id == info.id &&
                    this.selectedProduct.attributeList != info.attributeList
                ) {
                    selectedProduct = this.selectedProduct;
                } else {
                    selectedProduct = info;
                }
            }

            this.selectedProduct = selectedProduct;
            this.categoryIdx = categoryIdx;
            this.productIdx = productIdx;
            this.calcRealPrice();
            this.toggleLayer();
        },
        selectOption(idx, oidx) {
            let selectedProduct = JSON.parse(
                    JSON.stringify(this.selectedProduct)
                ),
                cartArr = JSON.parse(JSON.stringify(this.cartArr));
            for (let i in selectedProduct.attributeList[idx].valueList) {
                selectedProduct.attributeList[idx].valueList[i].isSelected =
                    i == oidx ? true : false;
            }
            console.log(
                "selectedProduct: ",
                selectedProduct,
                "cartArr:",
                cartArr
            );
            for (let i of cartArr) {
                if (
                    i.id == selectedProduct.id &&
                    JSON.stringify(i.attributeList) ==
                        JSON.stringify(selectedProduct.attributeList)
                ) {
                    console.log("same");
                    selectedProduct.qty = i.qty;
                    break;
                } else {
                    console.log(
                        "different",
                        i.attributeList,
                        selectedProduct.attributeList
                    );
                    selectedProduct.qty = 0;
                }
            }
            this.selectedProduct = selectedProduct;
            this.calcRealPrice();
        },

        // 计算商品的实际价格
        calcRealPrice() {
            let selectedProduct = JSON.parse(
                JSON.stringify(this.selectedProduct)
            );
            for (let i of selectedProduct.attributeList[0].valueList) {
                if (i.isSelected) {
                    selectedProduct.realPrice =
                        selectedProduct.price + i.addprice;
                    break;
                }
            }
            let propsTxt = "",
                propsIds = "";
            for (let i of selectedProduct.attributeList) {
                for (let j of i.valueList) {
                    if (j.isSelected) {
                        propsTxt += j.name + "，";
                        propsIds += j.id + ",";
                    }
                }
            }
            propsTxt = propsTxt.slice(0, propsTxt.length - 1);
            propsIds = propsIds.slice(0, propsIds.length - 1);
            selectedProduct.propsTxt = propsTxt;
            selectedProduct.propsIds = propsIds;
            this.selectedProduct = selectedProduct;
        },
        addToCart() {
            let cartArr = this.cartArr,
                selectedProduct = this.selectedProduct,
                productList = this.productList,
                categoryIdx = this.categoryIdx,
                productIdx = this.productIdx;
            selectedProduct.qty = selectedProduct.qty
                ? selectedProduct.qty + 1
                : 1;
            productList[categoryIdx][1][productIdx].qty = productList[
                categoryIdx
            ][1][productIdx].qty
                ? productList[categoryIdx][1][productIdx].qty + 1
                : 1;
            cartArr.push(selectedProduct);
            console.log("cartArr", cartArr);
            this.selectedProduct = selectedProduct;
            this.productList = productList;
            this.cartArr = cartArr;
            this.calcCartTotal();
        },
        // 计算购物车内商品总价
        calcCartTotal() {
            let cartArr = this.cartArr,
                cartTotal = 0,
                cartQty = 0;
            for (let i of cartArr) {
                cartTotal += i.realPrice * i.qty;
                cartQty += i.qty;
            }
            this.cartTotal = cartTotal;
            this.cartQty = cartQty;
        },
        toggleLayer() {
            this.showProps = !this.showProps;
        },
        toggleCart() {
            if (!this.cartArr.length) {
                return;
            }
            this.showCart = !this.showCart;
        },
        changeQty(type) {
            let selectedProduct = this.selectedProduct,
                productList = this.productList,
                categoryIdx = this.categoryIdx,
                productIdx = this.productIdx,
                cartArr = this.cartArr;
            if (type == "add") {
                selectedProduct.qty += 1;
            } else {
                if (selectedProduct.qty > 0) {
                    selectedProduct.qty -= 1;
                }
            }
            console.log("cartArr", this.cartArr);
            for (let i in cartArr) {
                if (
                    cartArr[i].id == selectedProduct.id &&
                    JSON.stringify(cartArr[i].attributeList) ==
                        JSON.stringify(selectedProduct.attributeList)
                ) {
                    cartArr[i].qty = selectedProduct.qty;
                    if (cartArr[i].qty < 1) {
                        cartArr.splice(i, 1);
                    }
                    break;
                }
            }
            let productQty = 0;
            for (let i in cartArr) {
                if (cartArr[i].id == selectedProduct.id) {
                    productQty += cartArr[i].qty;
                }
            }
            productList[categoryIdx][1][productIdx].qty = productQty;
            this.selectedProduct = selectedProduct;
            this.productList = productList;
            this.cartArr = cartArr;
            this.calcCartTotal();
        },
        modifyCartNum(type, idx) {
            let productList = this.productList,
                cartArr = this.cartArr;
            switch (type) {
                case "add":
                    cartArr[idx].qty += 1;
                    break;
                case "minus":
                    cartArr[idx].qty -= 1;
                    break;
            }
            let productQty = 0;
            for (let i of cartArr) {
                if (i.id == cartArr[idx].id) {
                    productQty += i.qty;
                }
            }
            for (let i of productList) {
                for (let j of i[1]) {
                    if (j.id == cartArr[idx].id) {
                        j.qty = productQty;
                        break;
                    }
                }
            }
            if (cartArr[idx].qty < 1) {
                cartArr.splice(idx, 1);
            }
            if (!cartArr.length) {
                this.showCart = false;
            }
            this.cartArr = cartArr;
            this.productList = productList;
            this.calcCartTotal();
        },
        checkOut() {
            this.setLocal("xbkCartArr", this.cartArr);
            this.$router.push({
                path: "/xbkCheckout",
                query: {
                    cartTotal: this.cartTotal,
                    expressfee: this.expressfee,
                },
            });
        },
    },
};
</script>
<style lang="scss">
.xbk_menu_wrap {
    .menu_bar {
        font-size: 28px;
        width: 159px;
        height: 100%;
        background: #f4f4f4;
        position: fixed;
        left: 0;
        top: 0;
        overflow-y: scroll;
        border-right: 1px solid #dededf;
        padding-bottom: 100px;
        .menu_item {
            width: 100%;
            display: inline-block;
            font-size: 26px;
            background: #f4f4f4;
            padding: 50px 20px;
            box-sizing: border-box;
            color: #666;
            line-height: 36px;
        }
        .active {
            background: #fff;
            color: #000;
        }
    }
    .product_list {
        width: calc(100% - 160px);
        height: 100%;
        position: fixed;
        right: 0;
        top: 0;
        overflow-y: scroll;
        background: #fff;
        padding-bottom: 100px;
        .section {
            .section_title {
                width: 100%;
                padding: 0 20px;
                box-sizing: border-box;
                height: 70px;
                line-height: 70px;
                font-size: 32px;
            }
            .product_item {
                width: 100%;
                padding: 20px;
                box-sizing: border-box;
                img {
                    width: 180px;
                    height: 180px;
                    border-radius: 10px;
                    margin-right: 20px;
                }
                .product_info {
                    width: calc(100% - 200px);
                    height: 180px;
                    h4 {
                        font-size: 28px;
                    }
                    .price {
                        font-size: 28px;
                        color: #e42f46;
                    }
                    .btn_wrap {
                        position: relative;
                        height: 50px;
                        button {
                            background: #306f47;
                            color: #fff;
                            font-size: 26px;
                            height: 50px;
                            line-height: 50px;
                            padding: 0 10px;
                            border-radius: 10px;
                        }
                        .qty {
                            background: #d62f35;
                            color: #fff;
                            position: absolute;
                            font-size: 22px;
                            top: -20px;
                            right: -8px;
                            height: 32px;
                            line-height: 32px;
                            min-width: 32px;
                            border-radius: 16px;
                            text-align: center;
                            padding: 0 5px;
                        }
                    }
                }
            }
        }
    }
    .footer {
        width: 100%;
        height: 100px;
        position: fixed;
        bottom: 0;
        background: #fff;
        z-index: 6;
        .footer_left {
            margin-left: 30px;
            .icon_wrap {
                width: 80px;
                height: 80px;
                margin-right: 20px;
                position: relative;
                img {
                    width: 80px;
                    height: 80px;
                }
                .total {
                    background: #d62f35;
                    color: #fff;
                    position: absolute;
                    font-size: 22px;
                    top: -5px;
                    right: -5px;
                    height: 32px;
                    line-height: 32px;
                    min-width: 32px;
                    border-radius: 16px;
                    text-align: center;
                    padding: 0 5px;
                }
            }
            .total_price {
                color: #d62f35;
                font-size: 32px;
                margin-right: 20px;
            }
            .delivery {
                font-size: 28px;
                color: #999;
                margin-top: 5px;
            }
        }
        button {
            font-size: 32px;
            width: 200px;
            height: 100px;
            line-height: 100px;
            border-radius: 0;
        }
        .btn_disable {
            background: #eee;
            color: #999;
        }
        .btn_active {
            background: #306f47;
            color: #fff;
        }
    }
    .option_layer {
        width: 650px;
        max-height: 750px;
        background: #fff;
        border-radius: 10px;
        z-index: 12;
        position: fixed;
        top: calc(50% - 450px);
        left: 50px;
        h4 {
            font-size: 32px;
            color: #666;
            height: 70px;
            line-height: 70px;
            width: 100%;
            padding: 0 30px;
            box-sizing: border-box;
            text-align: center;
        }
        .props {
            width: 100%;
            padding: 0 30px 100px 30px;
            box-sizing: border-box;
            font-size: 28px;
            max-height: 580px;
            overflow-y: scroll;
            .prop {
                h5 {
                    height: 60px;
                    line-height: 60px;
                }
                .options {
                    .option {
                        padding: 0 15px;
                        height: 60px;
                        line-height: 60px;
                        border: 1px solid #aaa;
                        color: #aaa;
                        margin: 0 20px 20px 0;
                        border-radius: 5px;
                        min-width: 80px;
                        text-align: center;
                    }
                    .selected {
                        border: 1rpx solid #306f47;
                        color: #306f47;
                        background: rgba(48, 111, 71, 0.1);
                    }
                }
            }
        }
        .layer_footer {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            padding: 0 30px;
            box-sizing: border-box;
            height: 99px;
            border-top: 1px solid #eee;
            background: #fff;
            border-radius: 0 0 10px 10px;
            .price_wrap {
                .option_price {
                    font-size: 32px;
                    color: #e42f46;
                }
                .option_detail {
                    font-size: 24px;
                    color: #aaa;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    max-width: 320px;
                    margin-left: 10px;
                }
            }
            button {
                background: #306f47;
                color: #fff;
                font-size: 26px;
                height: 50px;
                line-height: 50px;
                padding: 0 10px;
                border-radius: 10px;
            }
            .option_num {
                .operate {
                    width: 40px;
                    height: 40px;
                    line-height: 40px;
                    border: 1px solid #999;
                    color: #999;
                    border-radius: 50%;
                    font-size: 32px;
                }
                .num {
                    width: 60px;
                    text-align: center;
                    font-size: 32px;
                }
            }
        }
    }
    .cart_layer {
        width: 100%;
        position: fixed;
        z-index: 5;
        bottom: 0;
        right: 0;
        padding-bottom: 100px;
        animation: showUp 0.8s;
        .cart_items {
            max-height: 580px;
            overflow-y: scroll;
            .cart_item_wrap {
                display: inline-block;
                width: 100%;
                .cart_item {
                    background: #fff;
                    width: 100%;
                    height: 170px;
                    padding: 20px 30px;
                    box-sizing: border-box;
                    border-bottom: 1px solid #eee;
                    .item_pic {
                        width: 130px;
                        height: 130px;
                        background: #eee;
                        margin-right: 20px;
                        border-radius: 10px;
                    }
                    .item_info {
                        width: calc(100% - 150px);
                        height: 130px;
                        h5 {
                            font-size: 32px;
                        }
                        .item_prop {
                            font-size: 22px;
                            color: #999;
                        }
                        .item_price {
                            font-size: 32px;
                            color: #e42f46;
                        }
                        .item_num {
                            .operate {
                                width: 40px;
                                height: 40px;
                                line-height: 40px;
                                border: 1px solid #999;
                                color: #999;
                                border-radius: 50%;
                                font-size: 32px;
                            }
                            .num {
                                width: 60px;
                                text-align: center;
                                font-size: 32px;
                            }
                        }
                    }
                }
            }
        }
    }
    @keyframes showUp {
        from {
            bottom: -600px;
            right: 0;
        }

        to {
            bottom: 0;
            right: 0;
        }
    }
    .shade {
        width: 100%;
        height: 100%;
        position: fixed;
        left: 0;
        top: 0;
        background: rgba(0, 0, 0, 0.5);
        z-index: 4;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/xbk/xbkMenu.vue